<div class="circle status-{{ status.toString().toLowerCase() }}" [ngClass]="{ disabled: isOffline, small: useSmall }">
  <span class="circle__content">
    @if (showLightning) {
      <span class="circle__bolt" aria-hidden="true">&#128498;</span>
    }
    <span>{{ symbol }}</span>
  </span>
</div>

